exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards-grid[data-v-a1479720]{display:grid;grid-template-columns:repeat(auto-fit,minmax(290px,1fr));gap:1.2em}", ""]);

// exports
